module.exports = __webpack_public_path__ + "img/tratsem.bc137ca4.png";